<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator" v-if="info.User && info.ProjectsLength > 1">
            <div class="control-block-left">
                <project-select :user="info.User" @onChange="onProjectChange"></project-select>
            </div>
        </div>

        <div class="body-panel-content body-panel-content-page" @scroll="onScroll">
            <div class="block-in-page">
                <div v-if="!items.length">
                    <p class="input-text-lbl">Выберите вознаграждения в разделе «{{ getPageTitle('/spend-bonuses') }}»</p>
                </div>
                <div v-if="items.length > 0">
                    <h2 class="margin-bottom-20">Подтверждение выбранных вознаграждений</h2>
                    <div v-if="isMobile">
                        <div v-for="item of items" class="table-div">
                            <div style="font-weight:600;font-size:14px">{{ item.Name }}</div>
                            <div class="flex margin-top-2">
                                <div style="width:50%;">Номинал</div>
                                <div style="width:50%;text-align:right">{{ item.Price }}</div>
                            </div>
                            <div class="flex margin-top-2">
                                <div style="width:50%">Количество</div>
                                <div style="width:50%;text-align:right">
                                    <touch-spin v-model.number="item.Count" @change="onCountChange(item)" v-if="item.RewardType !== 1 && item.RewardType !== 2"></touch-spin>
                                    <template v-if="item.RewardType === 1 || item.RewardType === 2">
                                        {{item.Count}}
                                    </template>
                                </div>
                            </div>
                            <div class="flex margin-top-2">
                                <div style="width:50%;">Сумма</div>
                                <div style="width:50%;text-align:right">{{ (item.Price * item.Count).toFixed(2) }}</div>
                            </div>
                            <div class="margin-top-5" style="text-align:right">
                                <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveItem(item)" style="display:initial">
                                    <img src="../../img/icon-del.png" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <table id="dataTable" class="table-view margin-top-10" cellspacing="0" v-if="!isMobile">
                        <thead>
                            <tr class="heading">
                                <th>Наименование</th>
                                <th>Номинал</th>
                                <th>Кол-во</th>
                                <th>Сумма</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item of items">
                                <td>{{ item.Name }}</td>
                                <td class="value">{{ item.Price }}</td>
                                <td class="value">
                                    <touch-spin v-model.number="item.Count" @change="onCountChange(item)" v-if="item.RewardType !== 1 && item.RewardType !== 2"></touch-spin>
                                    <template v-if="item.RewardType === 1 || item.RewardType === 2">
                                        {{item.Count}}
                                    </template>
                                </td>
                                <td class="value">
                                    {{ (item.Price * item.Count).toFixed(2) }}
                                </td>
                                <td class="obtn">
                                    <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveItem(item)">
                                        <img src="../../img/icon-del.png" alt="" />
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" style="text-align: right;">
                                    <strong>Итого: {{ getTotalPrice().toFixed(2)}}</strong>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="margin-top-15" v-if="info.User && info.User.ActiveBalanceWithOrders < getTotalPrice()">
                        <span class="error">
                            Стоимость вознаграждения превышает количество баллов, доступных для оплаты.
                        </span>
                    </div>
                    <div class="margin-top-15">
                        <button type="button" class="btn" @click="makeOrder()" :disabled="info.User && info.User.ActiveBalanceWithOrders < getTotalPrice()">
                            Оформить заказ
                        </button>
                    </div>
                </div>
            </div>
            <div class="block-in-page">
                <div v-if="orders.length">
                    <h2 class="margin-bottom-20">Подтвержденные вознаграждения</h2>
                    <div v-if="isMobile">
                        <div v-for="order of orders" class="table-div">
                            <div class="caption-help">
                                {{ formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm') }}
                            </div>
                            <div class="flex margin-top-5">
                                <div style="width:50%;font-weight:600;font-size:14px">{{ order.Reward.Name }}</div>
                                <div style="width:50%;text-align:right">{{ order.Count }} шт.</div>
                            </div>
                            <div class="flex margin-top-2">
                                <div style="width:50%"><p v-html="getOrderStatus(order)"></p></div>
                                <div style="width:50%;text-align:right">{{ (order.Amount).toFixed(2) }}</div>
                            </div>
                            <div class="margin-top-5" v-if="order.Status === 1 || order.Status === 4 || order.Status === 5">
                                <button type="button" class="btn" @click="receiveOrder(order)" v-if="order.Reward.RewardType === 1 && (order.Status === 4 || order.Status === 5)">
                                    Скачать
                                </button>
                                <button type="button" class="btn" @click="receiveOrder(order)" v-if="order.Reward.RewardType === 2 && order.Status === 4">
                                    Карта получена
                                </button>
                                <button type="button" class="btn" @click="removeOrder(order)" v-if="order.Status === 1">
                                    Отменить заказ
                                </button>
                            </div>
                        </div>
                    </div>
                    <table class="table-view" cellspacing="0" v-if="!isMobile">
                        <thead>
                            <tr class="heading">
                                <th>Дата размещения</th>
                                <th>Наименование</th>
                                <th>Кол-во</th>
                                <th>Сумма</th>
                                <th>Статус</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="order of orders">
                                <td class="datetime">{{ formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm') }}</td>
                                <td>{{ order.Reward.Name }}</td>
                                <td class="value-center">{{ order.Count }}</td>
                                <td class="value-center">
                                    {{ (order.Amount).toFixed(2) }}
                                </td>
                                <td class="state">
                                    <p v-html="getOrderStatus(order)"></p>
                                </td>
                                <td class="obtn">
                                    <button type="button" class="btn" @click="receiveOrder(order)"
                                            v-if="order.Reward.RewardType === 1 && (order.Status === 4 || order.Status === 5)">
                                        Скачать
                                    </button>
                                    <button type="button" class="btn" @click="receiveOrder(order)" v-if="order.Reward.RewardType === 2 && order.Status === 4">
                                        Карта получена
                                    </button>
                                    <button type="button" class="btn btn-img" @click="removeOrder(order)" v-if="order.Status === 1">
                                        <img src="../../img/icon-del.png" alt="" />
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import cart from '../cart'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import UI from '../helpers/ui-helpers'
    import {RewardTypes, VerificationStates} from '../enums'

    let backendApi = new BackendApi();

    export default {
        name: "cart",

        props: ['info'],

        mixins: [projectMixin],

        data(){
            return {
                cartItems: [],
                rewards: [],
                orders: [],
                isMobile: UI.check_mobile(),
                orderProcessing: false,
                isLoading: false,
                canBeLoaded: true,
                page: 1
            }
        },

        computed:{
            items() {
                let vm = this;
                return this.cartItems.map((x) => {
                    let reward = vm.rewards.find(y => x.Id === y.Id);
                    if (reward !== undefined) {
                        let priceItem = reward.Prices && reward.Prices.find(y => x.PriceId === y.Id);
                        let price = priceItem ? priceItem.Price : null;
                        //if ((reward.RewardType == RewardTypes.PhysicalBankCard || reward.RewardType === RewardTypes.ElectronicGiftCard && reward.OzonCertificate)
                        if(reward.RewardType !== RewardTypes.PhysicalPrize && !priceItem && x.Price) {
                            price = x.Price;
                        }
                        return {
                            Id: reward.Id,
                            PriceId: x.PriceId,
                            Name: reward.Name,
                            Price: price,
                            Count: x.Count,
                            Image: reward.Image,
                            RewardType: reward.RewardType,
                            AddressId: x.AddressId
                        };
                    }
                }).filter(x => x.Price);
            }
        },

        methods: {
            reload() {
                this.orders = [];
                this.page = 1;
                this.canBeLoaded = true;
                this.loadOrders();
            },

            loadRewards() {
                let vm = this;
                UI.blockUI('.dataContent', 'Загрузка...');
                return this.callApiWrapper(backendApi.rewardsList(0, 100, vm.projectId, vm.search))
                    .then(function (resp) {
                        if (resp.data) {
                            vm.rewards = resp.data;
                        }
                        UI.unblockUI('.dataContent');
                    });
            },

            loadOrders() {
                let vm = this;
                let rowsPerPage = 50;
                vm.isLoading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.ordersList((this.page - 1) * rowsPerPage, rowsPerPage, vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки заказов');
                        }
                        else {
                            if (resp.data && resp.data.list) {
                                //vm.orders = resp.data.list;
                                vm.orders.push(...resp.data.list);
                                vm.canBeLoaded = resp.data.list.length === rowsPerPage;
                            }
                            else {
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.isLoading = false;
                    });
            },

            getOrderStatus(order) {
                let vm = this;

                switch (order.Status) {
                    case 1:
                        return 'Размещён';
                    case 2:
                    case 8:
                        return 'В обработке';
                    case 3:
                        if (order.Comment) {
                            return `Отменён по причине:<br />${order.Comment}`;
                        }
                        return 'Отменён';
                    case 4:
                        if (order.Reward.RewardType === 1) {
                            // Электронная подарочная карта
                            return 'Выдан';
                        }
                        else if (order.Reward.RewardType === 2) {
                            // Предоплаченная банковская карта
                            return 'Выдан (карта отправлена)';
                        }
                        else if (order.Reward.RewardType === 3) {
                            // Пополнение личной карты
                            return 'Выдан (перевод осуществлён)';
                        }
                        else if (order.Reward.RewardType === 4) {
                            // приз
                            return 'Отправлен';
                        }
                        else {
                            return '';
                        }
                    case 5:
                        if (order.Reward.RewardType === 1) {
                            // Электронная подарочная карта
                            let status = 'Скачан';

                            if (order.FirstRecievedDate) {
                                status += (vm.isMobile ? ' ' : '<br>') + vm.formatDate(order.FirstRecievedDate, 'DD.MM.YYYY HH:mm');
                            }

                            return status;
                        }
                        else if (order.Reward.RewardType === RewardTypes.PrepaidBankCard) {
                            // Предоплаченная банковская карта
                            return 'Карта получена';
                        }
                        else if (order.Reward.RewardType === RewardTypes.PhysicalPrize) {
                            // приз
                            return 'Получен';
                        }
                        else {
                            return '';
                        }
                    case 6:
                        return 'В обработке';
                    default:
                        return '';
                }
            },

            onRemoveItem(item) {
                let vm = this;

                cart.removeItem(item.Id);
                vm.cartItems = cart.getItems();
                vm.$emit('need-refresh-cart');
            },

            onCountChange(item) {
                let vm = this;

                if (item.Count === 0) {
                    vm.onRemoveItem(item);
                }
                else {
                    cart.updateItemCount(item);
                    vm.cartItems = cart.getItems();
                    vm.$emit('need-refresh-cart');
                }
            },

            getTotalPrice() {
                let sum = 0;
                for (let item of this.items) {
                    sum += item.Price * item.Count;
                }
                return sum;
            },

            makeOrder() {
                let vm = this;

                if(vm.orderProcessing) {
                    return;
                }

                let counterPhysicalBankCardBan = 0;
                let orderItems = vm.items.map(x => {
                    if(x.RewardType !== RewardTypes.PhysicalBankCard || (vm.info.User.PaymentSettings && vm.info.User.PaymentSettings.VerificationState === VerificationStates.Verified)) {
                        return {Id: x.Id, Count: x.Count, PriceId: x.PriceId, Price: x.Price, AddressId: x.AddressId}
                    } else {
                        counterPhysicalBankCardBan++;
                        return {Id: 0}
                    }
                }).filter(x => x.Id > 0);
                let orderRequest = {
                    items: orderItems
                };
                if(vm.items.length === counterPhysicalBankCardBan) {
                    UI.toastr.error('По некоторым вознограждениям нельзя оформлять заказ');
                    return;
                }

                vm.orderProcessing = true;

                UI.blockUI('dataContent', 'Сохранение');
                this.callApiWrapper(backendApi.orderPlace(orderRequest))
                    .then(function (response) {
                        //console.info('orderPlace -> response.data', response.data);
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при размещении заказа');
                            // todo: customize
                        } else {
                            UI.toastr.success('Заказ успешно размещён');

                            localStorage.removeItem('cart');
                            vm.cartItems = [];
                            vm.$emit('need-refresh-cart');
                            vm.$emit('user-updated');

                            vm.reload();
                        }

                        vm.orderProcessing = false;
                    });
            },

            receiveOrder(order) {
                let vm = this;

                UI.blockUI('dataContent', 'Обработка');
                this.callApiWrapper(backendApi.orderReceive(order.Id))
                    .then(function (response) {
                        //console.info('receiveOrder -> response.data', response.data);
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при обработке заказа');
                        }
                        else {
                            if (order.Reward.RewardType === RewardTypes.PrepaidBankCard) {
                                UI.toastr.success('Карта получена');
                            }
                            else if (order.Reward.RewardType === RewardTypes.ElectronicGiftCard) {
                                console.info('response.data', response.data)
                                vm.forceDownload(response.data, response.data.replace('/uploads/orders/', ''));
                            }

                            vm.orders = [];
                            vm.reload();
                        }
                    });
            },

            removeOrder(order) {
                let vm = this;

                UI.blockUI('dataContent', 'Обработка');
                this.callApiWrapper(backendApi.orderRemove(order.Id))
                    .then(function (response) {
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            console.info('error status', response.status);
                            UI.toastr.error('Ошибка при удалении заказа');
                        }
                        else {
                            vm.$emit('user-updated');

                            vm.orders = [];
                            vm.reload();
                            UI.toastr.success('Заказ удалён');
                        }
                    });
            },

            forceDownload(href, fileName) {
                let anchor = document.createElement('a');
                anchor.href = href;
                anchor.download = fileName;
                document.body.appendChild(anchor);
                anchor.click();
                anchor.remove();
            },

            onProjectChange(item){
                let vm = this;
                vm.projectId = item.Id;

                vm.loadRewards().then(()=>{
                    vm.cartItems = cart.getItems();
                });
                vm.reload();
            },

            onScroll(e) {
                let vm = this;
                if (!vm.isLoading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        vm.loadOrders();
                    }
                }
            }
        },

        mounted(){
            let vm = this;

            vm.loadRewards().then(()=>{
                vm.cartItems = cart.getItems();
            });
            vm.loadOrders();
        }
    }
</script>

<style scoped>
    .table-view thead{
        display: table-header-group;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/Cart.vue